export enum LPBaseURL {
  PRO = 'https://lp.maisretorno.com/retorno-pro',
  PRIME = 'https://lp.maisretorno.com/retorno-prime',
}

export enum UTMContent {
  CTA_PRIME_SESSION = 'cta_session',
  CTA_WINDOWS = 'janelas_moveis',
  CTA_GROSS_UP = 'gross_up',
  CTA_SIMULATION_DISPLAY_NAME = 'apelido_ativo',
  CTA_SIMULATION_DATES = 'datas_ativo',
  CTA_SCREENER_SAVE = 'salvar_rastreio',
  CTA_SCREENER_EXPORT = 'exportar',
  CTA_SCREENER_GROUP_BY = 'cta_agrupar',
  CTA_SCREENER_BASE_DATE = 'cta_data_base',
  CTA_COMPARISON_MORE_ASSETS = 'modal_10_ativos',
  CTA_PRIME_CARD = 'cta_prime_card',
  CTA_PRO_UPGRADE_CARD = 'cta_pro_upgrade_card',
  CTA_PRO_UPGRADE_SUBSCRIPTION = 'cta_upgrade_pro',
  CTA_SUBSCRIPTION_LIST = 'cta_lista_assinatura',
  CTA_HOME_PRO = 'cta_pro',
  CTA_SIMILAR_FUNDS = 'fundos_similares',
  CTA_NAVBAR = 'ctamenu',
  CTA_MOBILE_NAVBAR = 'cta_menu_mobile',
  CTA_PROFILE = 'cta_perfil',
  CTA_SIMULATION_COMPARISON = 'cta_comparar_simulacao',
  CTA_SUCCESS_RATE = 'cta_taxa_sucesso',
  CTA_MOVABLE_WINDOWS = 'cta_janelas_moveis',
}
